import { render, staticRenderFns } from "./SupportConversation.vue?vue&type=template&id=529c4d50&scoped=true&"
import script from "./SupportConversation.vue?vue&type=script&lang=js&"
export * from "./SupportConversation.vue?vue&type=script&lang=js&"
import style0 from "./SupportConversation.vue?vue&type=style&index=0&id=529c4d50&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "529c4d50",
  null
  
)

export default component.exports